import EE from 'eventemitter3';

export const EVENTS = { resize: 1 };
const Bus = new EE();

export default Bus;
